export const STATUS_LABEL = {
  requested: "Processing", under_review: "Processing", approved: "Pending payment", processing: "Processing",
  paid: "Paid", failed: "Failed", rejected: "Rejected", cancelled: "Cancelled", reversed: "Reversed",
};

export const STATUS_CLS = {
  approved: "bg-amber-100 text-amber-800", processing: "bg-sky-100 text-sky-800", requested: "bg-sky-100 text-sky-800",
  under_review: "bg-sky-100 text-sky-800", paid: "bg-[#0A2540] text-white", failed: "bg-rose-100 text-rose-800",
  rejected: "bg-slate-200 text-slate-700", cancelled: "bg-slate-200 text-slate-700", reversed: "bg-rose-100 text-rose-800",
};

export const fmtIST = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", timeZone: "Asia/Kolkata" }) : "—");
